export function formatAMPM(date) {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  const strTime =
    hours.toString().padStart(2, "0") + ":" + minutes + " " + ampm;
  return strTime;
}

export function getStartAndEndDate(selection) {
  const date = new Date();

  if (selection === "today") {
    const firstday = new Date(date.toDateString()).toISOString();
    return { startDate: firstday, endDate: firstday };
  }

  if (selection === "week") {
    const firstday = new Date(date.setDate(date.getDate() - date.getDay()));
    const lastday = new Date(date.setDate(date.getDate() - date.getDay() + 6));
    return {
      startDate: firstday.toISOString(),
      endDate: lastday.toISOString(),
    };
  }

  if (selection === "month") {
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return {
      startDate: firstDayOfMonth.toISOString(),
      endDate: lastDayOfMonth.toISOString(),
    };
  }

  if (selection === "year") {
    const firstDayOfYear = new Date(date.getFullYear(), 0, 1); // January 1st
    const lastDayOfYear = new Date(date.getFullYear(), 11, 31); // December 31st
    return {
      startDate: firstDayOfYear.toISOString(),
      endDate: lastDayOfYear.toISOString(),
    };
  }

  return { startDate: null, endDate: null };
}

export const getQueryVariable = (variable) => {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return "";
};

export const convertSecondsIntoMinutesAndHours = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor(seconds / 60) - hours * 60;
  const sec = seconds - (hours * 3600 + minutes * 60);
  return {
    hours,
    minutes,
    seconds: sec,
  };
};

export function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return [...array];
}

export function isNumberLiesInRange(min, max, num = "") {
  const minimum = Number(min);
  const maximum = Number(max);
  num = num.trim();
  if (!isNaN(num)) {
    const number = Number(num);
    return minimum < number && number < maximum;
  } else {
    if (num.includes("/")) {
      const arr = num.split("/");
      if (arr.length === 2 && !isNaN(arr[0]) && !isNaN(arr[1])) {
        const result = Number(arr[0]) / Number(arr[1]);
        return minimum < result && result < maximum;
      }
    }
  }
  return false;
}

function divideAndTruncate(a, b, decimalPlaces) {
  const result = a / b;
  return (
    Math.trunc(result * Math.pow(10, decimalPlaces)) /
    Math.pow(10, decimalPlaces)
  );
}

export function isNumberExact(num, question, suggestedOption) {
  const index = question?.options?.findIndex(
    (option) => typeof option === "object"
  );
  let option = "";
  if (index !== -1) {
    option = question?.options[index];
  } else {
    option = suggestedOption;
  }
  const errorMargin = option?.errorMargin ? Number(option?.errorMargin) : 0;
  num = num.trim();
  if (isNaN(num)) {
    if (num.includes("/")) {
      const arr = num.split("/");
      if (arr.length === 2 && !isNaN(arr[0]) && !isNaN(arr[1])) {
        const value = Number(option?.value);
        const result = divideAndTruncate(
          Number(arr[0]),
          Number(arr[1]),
          value.toString().includes(".")
            ? value.toString().split(".")[1].length
            : 0
        );
        return value + errorMargin >= result && value - errorMargin <= result;
      }
    }
  } else {
    const dataValue = Number(num);
    const value = Number(option?.value);
    // checking for string
    if (value.toString().includes(".")) {
      const isNeedToChange = value.toString().split(".")[1].length > 3;
      const val1 = Math.trunc(value * 1000) / 1000;
      const errMar1 =
        isNeedToChange &&
        errorMargin.toString().includes(".") &&
        errorMargin.toString().split(".")[1].length > 3
          ? errorMargin * 10
          : errorMargin;
      const val2 = Math.trunc(Math.round(value * 10000)) / 10000;

      return (
        (val1 + errMar1 >= dataValue &&
          val1 - errMar1 < dataValue &&
          dataValue.toString().split(".")[1].length ===
            val1.toString().split(".")[1].length) ||
        (errMar1 === 0 && val1 === dataValue) ||
        (val2 + errorMargin >= dataValue && val2 - errorMargin < dataValue)
      );
    }
    return (
      (value + errorMargin >= dataValue && value - errorMargin < dataValue) ||
      (dataValue === value && errorMargin === 0)
    );
  }
  return false;
}

export function isNumberWithPrecision(num = "", precisionVal, val) {
  num = num.trim();
  if (!isNaN(num)) {
    const number = Number(num);
    const precisionNumber = number % 1;
    const wholeNumber = parseInt(number);
    const value = Number(val);
    const precisionValue = value % 1;
    const wholeValue = parseInt(value);
    if (
      wholeNumber !== wholeValue ||
      (precisionNumber === 0 && Number(precisionVal) !== 0)
    ) {
      return false;
    }
    const validate = number.toString().split(".");
    if (validate?.length && validate[1]?.length !== parseInt(precisionVal)) {
      return false;
    }
    if (precisionNumber === precisionValue) {
      return true;
    }
    if (
      precisionNumber.toString().slice(0, precisionVal) ===
      precisionValue.toString().slice(0, precisionVal)
    ) {
      return true;
    }
  } else {
    if (num.includes("/")) {
      const arr = num.split("/");
      if (arr.length === 2 && !isNaN(arr[0]) && !isNaN(arr[1])) {
        const result = (Number(arr[0]) / Number(arr[1])).toFixed(
          Number(precisionVal)
        );
        if (Number(result) === Number(val)) {
          return true;
        }
        const firstWhole = parseInt(result);
        const secondWhole = parseInt(val);
        const firstPrecision = result % 1;
        const secondPrecision = Number(val) % 1;
        return (
          firstWhole === secondWhole &&
          firstPrecision.toString().slice(0, precisionVal) ===
            secondPrecision.toString().slice(0, precisionVal)
        );
      }
    }
  }
  return false;
}
